import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import DialogService from 'primevue/dialogservice'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import { PRIORITIES } from '@/core/constants/installation-priorities.constant'
import { Form, FormField } from '@/shared/primevue/forms'
import Lara from '@/shared/primevue/lara'
import { LOCALE_MAP } from '@/shared/primevue/locales'

import 'primeicons/primeicons.css'

export const priority = PRIORITIES.PRIMEVUE

export function install({ app }) {
  const initialLocale = localStorage.getItem('locale') || 'en'

  app
    .use(PrimeVue, {
      unstyled: true,
      pt: Lara,
      locale: LOCALE_MAP[initialLocale] || LOCALE_MAP.en,
      zIndex: {
        modal: 1100,
        overlay: 1200,
        menu: 1000,
        tooltip: 1100,
      },
    })
    .use(ConfirmationService)
    .use(DialogService)
    .use(ToastService)
    .component('Form', Form)
    .component('FormField', FormField)
    .directive('tooltip', Tooltip)

  app.config.globalProperties.$primevue = app.config.globalProperties.$primevue || {}
  app.config.globalProperties.$primevue.changeLocale = (locale) => {
    if (LOCALE_MAP[locale]) {
      app.config.globalProperties.$primevue.config.locale = LOCALE_MAP[locale]
    }
  }
}
